import React, { useState } from "react";
const GridColumnLayout = (props) => {
    return (
        <div className="grid-option">
            <div className="row">
                {props.colmLayout && props.colmLayout.map((col, index) => (
                    <div key={index} className={`col-${col}`}><div className="grid-column"></div></div>
                ))}
            </div>
        </div>
    );
}
export default GridColumnLayout;
